<div class="container">
  <input matInput
         [matDatepicker]="datePicker"
         [(ngModel)]="date"
         (click)="onInputClick()"
         tabindex="-1"
         [readonly]="openOnClick"
         [disabled]="isDisabled" />
  <mat-datepicker-toggle matSuffix
                         [hidden]="hideIcon"
                         [for]="datePicker">
    <i matDatepickerToggleIcon
       class="far fa-calendar-alt"></i>
  </mat-datepicker-toggle>
  <mat-datepicker #datePicker></mat-datepicker>
</div>
